// extracted by mini-css-extract-plugin
export default {"menu":"MenuDropdown_menu__Y2GNP","header":"MenuDropdown_header__0qTF0","icon":"MenuDropdown_icon__SOTqs","content":"MenuDropdown_content__KFIna","inner":"MenuDropdown_inner__lygNy"};